import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

type OutOfStockProductPageVisitParams = {
    productCode: string;
    baseProductCode: string;
    productName: string;
    variantCode: string;
};

/**
 * Info log for Datadog when a customer opens a hardcoded out-of-stock product PDP.
 * Facets: `@productCode`, `@baseProductCode`, `@productName`, `@variantCode`.
 */
export const logOutOfStockProductPageVisit = ({
    productCode,
    baseProductCode,
    productName,
    variantCode,
}: OutOfStockProductPageVisitParams) => {
    const datadogLogs = datadogLogger();

    datadogLogs.info('Out of stock product page visit', {
        component: DDComponent.EshopProduct,
        productCode,
        baseProductCode,
        productName,
        variantCode,
    });
};
